<template>
  <modal header-text="" :button-text="$t('global.delete')" @action="deleteItem" @close="$emit('close')">
    <div :class="$style.inputContainer">
      {{ output }}
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/common/modal/settings-modal.vue';
import { deleteProfile, deleteUser, deleteVacation } from '@/api/methods/settings';
import { deleteRule, deleteCategory } from '@/api/methods/security';

export default {
  components: { Modal },
  props: ['selected', 'type'],
  computed: {
    output() {
      switch (this.type) {
        case 'vacation':
          return this.$t('modal.confirmationMessages.deleteVacation', {
            startTime: this.selected?.startTime,
            endTime: this.selected?.endTime,
          });
        case 'date':
          return this.$t('modal.confirmationMessages.deleteDate', { date: this.selected });
        case 'user':
          return this.$t('modal.confirmationMessages.deleteUser');
        case 'profile':
          return this.$t('modal.confirmationMessages.deleteProfile');
        case 'ruleCategory':
          return this.$t('modal.confirmationMessages.deleteRuleCategory');
        default:
          return this.$t('modal.confirmationMessages.deleteRecord');
      }
    },
  },

  methods: {
    close() {
      this.$emit('close');
    },
    async deleteItem() {
      if (this.type === 'vacation') await deleteVacation(this.selected.id);
      if (this.type === 'date') this.$emit('deleteDate');
      if (this.type === 'user') await deleteUser(this.selected);
      if (this.type === 'profile') await deleteProfile(this.selected);
      if (this.type === 'rule') await deleteRule(this.selected);
      if (this.type === 'ruleCategory') {
        await deleteCategory(this.selected.id, this.selected.profile, this.selected.type);
      }
      this.close();
      this.$emit('update');
    },
  },
};
</script>

<style lang="scss" module>
  .input {
    margin: 5px;
  }
  .inputContainer {
    font-size: 13px;
    margin: 5px;
  }
</style>
